import { required, TextInput, SelectInput, ReferenceInput, AutocompleteInput, maxLength } from "react-admin";

import { Grid } from "@mui/material";
import { GenderOptionsId, PersonIdTypes } from "utils/choices";
import {
  documentNumberValidator,
  nameCyrillicRegexValidator,
  nameLatinRegexValidator,
  validateSecondName,
} from "utils/validations";

import PersonIdInput from "./PersonIdInput";
import { SectionTitle } from "features/SectionTitle";
import { administrationRequests } from "api/administrationApi";

const CandidateInfo = ({ isDisable, userData, citizenshipId }) => {
  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
      >
        <SectionTitle paddingY={2} title="Лични данни" />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          source="candidateInfo.firstNameBg"
          label="Име"
          defaultValue={userData?.candidateInfo?.firstNameBg}
          validate={[required("Задължително"), nameCyrillicRegexValidator]}
          readOnly={isDisable}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          source="candidateInfo.secondNameBg"
          label="Презиме"
          defaultValue={userData?.candidateInfo?.secondNameBg || ""}
          readOnly={isDisable}
          validate={[validateSecondName, nameCyrillicRegexValidator]}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          source="candidateInfo.lastNameBg"
          label="Фамилия"
          defaultValue={userData?.candidateInfo?.lastNameBg || ""}
          validate={[required("Задължително"), nameCyrillicRegexValidator]}
          readOnly={isDisable}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <SelectInput
          source="candidateInfo.personIdType"
          choices={PersonIdTypes.filter(t => t.id !== 1)}
          label="Тип идентификатор"
          validate={required("Задължително")}
          readOnly={isDisable}
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={4}
      >
        <PersonIdInput
          isDisable={isDisable}
          userData={userData}
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          label="Телефон"
          source="candidateInfo.phoneNumber"
          defaultValue={userData?.candidateInfo?.phoneNumber}
          validate={required("Задължително")}
          readOnly={isDisable}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          source="candidateInfo.email"
          label="Имейл"
          defaultValue={userData?.candidateInfo?.email || ""}
          validate={required("Задължително")}
          readOnly={isDisable}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <SelectInput
          label="Пол"
          source="candidateInfo.gender"
          choices={GenderOptionsId}
          validate={required("Задължително")}
          fullWidth
          defaultValue={userData?.candidateInfo?.gender}
          readOnly={isDisable}
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={4}
      >
        <ReferenceInput
          reference={administrationRequests.getCitizenshipSelect()}
          source="candidateInfo.citizenship"
          filter={{ IsForeigner: true }}
        >
          <AutocompleteInput
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
            optionText="name"
            optionValue="id"
            defaultValue={userData?.candidateInfo?.citizenship || citizenshipId}
            validate={required("Задължително")}
            label="Тип Гражданство ЕС / Извън ЕС"
            readOnly={isDisable}
            fullWidth
          />
        </ReferenceInput>
      </Grid>

      <Grid
        item
        xs={12}
        md={4}
      >
        <ReferenceInput
          reference={administrationRequests.getCountriesSelect()}
          source="candidateInfo.primaryCitizenshipCountryId"
        >
          <AutocompleteInput
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
            optionText="nameBg"
            defaultValue={userData?.candidateInfo?.primaryCitizenshipCountryId || null}
            validate={required("Задължително")}
            label="Гражданство"
            readOnly={isDisable}
            fullWidth
          />
        </ReferenceInput>
      </Grid>

      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          source="candidateInfo.personalDocumentNumber"
          label="Номер на документ за самоличност"
          validate={[required("Задължително"), maxLength(50), documentNumberValidator()]}
          readOnly={isDisable}
        />
      </Grid>
      <Grid
        item
        xs={12}
      >
        <SectionTitle paddingY={2} title="Имена на латиница" />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          source="candidateInfo.firstNameEn"
          label="Име"
          defaultValue={userData?.candidateInfo?.firstNameEn}
          readOnly={isDisable}
          validate={[required("Задължително"), nameLatinRegexValidator]}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          source="candidateInfo.secondNameEn"
          defaultValue={userData?.candidateInfo?.secondNameEn || null}
          label="Презиме"
          validate={[validateSecondName, nameLatinRegexValidator]}
          readOnly={isDisable}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          source="candidateInfo.lastNameEn"
          label="Фамилия"
          defaultValue={userData?.candidateInfo?.lastNameEn}
          readOnly={isDisable}
          validate={[required("Задължително"), nameLatinRegexValidator]}
        />
      </Grid>
    </Grid>
  );
};
export default CandidateInfo;
